import { ComponentOptions, reactive, ref } from "vue";
import { FinderService } from "./finder.service";
import { ISuggestion } from "./ISuggestion";
import useMainStore from '../stores/main.store';
import { FieldNames } from "../stores/field-names";
class SearchComponent {
  public suggestions: ISuggestion[] = reactive<ISuggestion[]>([]);
  public field = reactive({ word: '' });
  public isHidden = ref(false);
  public isModalVisible = ref(false);
  public isFormSent = true;

  public search(): void {
    this.isHidden.value = false;
    let debounce;
    if (this.field.word.endsWith(" ") && this.field.word.trim().length > 3) {
      clearTimeout(debounce);
      debounce = setTimeout(() => {
        console.log('debounce', this.field.word);
        (new FinderService()).getAddresses(this.field.word).then((result) => {
          this.suggestions = result;
          console.log(this.suggestions);
          this.suggestions.push({ formattedAddress: "Can't find", id: "" });
        })
      }, 400);

    }
  }

  selectAddress(address?: ISuggestion): void {

    // address have min 20 characters
    const isLocation = this.field.word.length < 20 && !address;

    if (isLocation) {
      return;
    }

    //close suggestions dropdown
    this.isHidden.value = true;

    //show modal
    this.isModalVisible.value = true;

    if (address) {
      this.field.word = address.formattedAddress;
      console.log(address);
      if (address.id) {
        // window.location.href = window.location.origin + `/nbn-plans/?id=${address.id}`;
      }
    }
    // save address in state
    const mainStore = useMainStore();
    mainStore.store(FieldNames.Address, this.field.word);
  }

  send() {
    const companyStore = useMainStore();

    if (companyStore.$state.valid) {
      (new FinderService()).saveContact(companyStore.getAll());
      this.isModalVisible.value = false
    }
    // else {
    //    this.isModalVisible.value = false
    // }
  }

}
export default new SearchComponent();